export default {
      id: "contacts_old-usage",
      viewBox: "0 0 95 70",
      url: "../dist/images/" + "sprite.svg#contacts_old-usage",
      toString: function () {
        return this.url;
      }
    }